import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import {PostData} from '../services/PostData';
import {GetData} from '../services/GetData';
import {
  Row,
  Col,
  Button,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Card,
  CardHeader,
  CardFooter,
  CardBody,
  Collapse,
  Form,
  FormGroup,
  FormText,
  Label,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Table
} from 'reactstrap';
import $ from 'jquery'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import StudentPage from '../views/StudentPage';
const GLOBAL = require('../Globals');

class EditPromotion extends Component {
	
	/** set property value **/
	constructor(props){
		super(props);
		this.state = {
			id : '',
			acyear : '',
			cls : '',
			section : '',
			acyear1 : '',
			cls1 : '',
			section1 : '',
			_message : '',
			alertClass :'',
			posts : [],
			data : [],
			postFilter : [],
			accyear : [],
			 _redirect : false,
			 att : [],
			 secs : [],
			 sections : []
		}
		this.basestate = this.state;
		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.printDocument = this.printDocument.bind(this);
		this.onClassChange = this.onClassChange.bind(this);
		this.onSectionChange = this.onSectionChange.bind(this);
	}
	
	 printDocument() {
		const input = document.getElementById('printableTable');
		html2canvas(input)
		  .then((canvas) => {
			const imgData = canvas.toDataURL('image/png');
			const pdf = new jsPDF();
			pdf.addImage(imgData, 'JPEG', 0, 0);
			pdf.save("download.pdf");
		  })
		;
		/* window.frames["print_frame"].document.body.innerHTML = document.getElementById("printableTable").innerHTML;
         window.frames["print_frame"].window.focus();
         window.frames["print_frame"].window.print(); */
		
	 }
	
	onSecChange(id,e){
		
		var index = this.state.att.findIndex(function(obj){
		// var obj=JSON.parse(objstr);
		return (obj.regno == id); });
		
		if(index === -1){ 
			this.state.att.push({"regno":id, "section":e.target.value, "status":'promoted', "remarks":0});
		}
		else{
			
			this.state.att[index].section = e.target.value;
		}
	}
	
	onRemarkChange(id,e){
		
		if(e.target.value!=''){
			var index = this.state.att.findIndex(function(obj){
			return (obj.regno == id); });
			
			if(index != -1){ 
				
				this.state.att[index].remarks = e.target.value;
				
			}
		}
	}
	
	onStatusChange(id,e){
		
		var index = this.state.att.findIndex(function(obj){
		// var obj=JSON.parse(objstr);
		return (obj.regno == id); });
		
		if(index === -1){ 
			this.state.att.push({"regno":id,"status":e.target.value, "remarks":0});
		}
		else{
			
			this.state.att[index].status = e.target.value;
		}
	}
	
	onChange(e){
		this.setState({[e.target.name]:e.target.value});
		this.getdata();
		this.getclass();
	}
	
	onSectionChange(e){
		
		this.state.section = e.target.value;
		this.filterdata();
	}

	onClassChange(e){
		
		this.state.cls = e.target.value;
		var ar = $("#year").val();
		if(ar!=''){
			$("#showLoader").show();
			GetData('section/getsecbyclass/'+ar+'/'+e.target.value).then((result) => {
				 $("#showLoader").hide();
				let res = result;
				if(res){
					this.setState({sections : res});
				}
			});
		}
		this.filterdata();
	}
	
	onSubmit(e){
		e.preventDefault();
		if (window.confirm("Do you want to Promote?")) {
				$("#showLoader").show();
			PostData('student/editpromotion',this.state).then((result) => {
				$("#showLoader").hide();
				let responseJson = result;
				if(responseJson.status == '1' ){
					document.getElementById("editproform").reset();
					$("#stdtable").hide();
				}
				else{
			
					this.setState({
						_message:'Error',
						alertClass:'alert alert-danger'
					});
				}
			});
		}
	}
	
	componentWillMount() {
		 
		this.getacyear();
	}
	
	/** get Academic Year **/
	getacyear(){
		
		GetData('academic/getacyear').then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					accyear : responseJson
				});
			}
		});
	}
	
	/** get Class **/
	getclass(){
		
		var ac = $("#year").val();
		GetData('classs/getclasbyacyear/'+ac).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					posts : responseJson
				});
			}
		});
	}
	
	/** get Student Data **/
	getdata(){
		
		this.setState({data : []});
		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('student/getstddetails/'+ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if(responseJson){
				this.setState({
					data : responseJson,
					postFilter : responseJson
				});
			}
		});
	}
	
	filterdata(){
		
		this.state.postFilter = [];
		var dat = [];
		for(var i=0; i<this.state.data.length; i++){
			
			if(this.state.cls != '' && this.state.section != ''){
				
				if(this.state.data[i].class == this.state.cls && this.state.data[i].section == this.state.section){
					
					dat.push(this.state.data[i]);
				}
			}
			
		}
		this.setState({postFilter : dat});
	}
	
  render() {
	
	if(this.state._redirect){
		  
		return (<Redirect to={'/leave/editcategory/' + this.state.idd} />);

	}
	
	/** set status select box **/
	this.stdstatus = [
		{value : 'pass', name : 'Pass'},
		{value : 'fail', name : 'Fail'},
		{value : 'transfer', name : 'Transfer'}
	];
	
	var items = this.state.posts;
	var items1 = this.state.posts1;
	var sec = this.state.sections;
	var acyear = this.state.accyear;
	
	if(this.state.acyear!='' && this.state.cls!='' && this.state.section!=''){
			
		$("#stdtable").show();
		$("#todata").show();
	}
	else{
		
		$("#stdtable").hide();
		$("#todata").hide();
	}
	
    return (
		<div>
		  <StudentPage />
			<div className="animated fadeIn">
				<div className={this.state.alertClass}>
					{this.state._message}
				</div>
			<form action="" method="post" role="form" id="editproform" encType="multipart/form-data" onSubmit={this.onSubmit} >
				<Row>
				  <Col md="12">
					<Card>
						<CardHeader>
							<strong>Section Edit</strong>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
							Academic Year : &nbsp;&nbsp;
							<select name="acyear" onChange={this.onChange} required id="year">
								<option value="">Select Academic Year</option>
								{
									acyear.map(function (item) {
										return <option value={item.id }>{item.value}</option>;
									})
								}
							</select>&nbsp;&nbsp;
							Class : &nbsp;&nbsp;
							<select name="cls" onChange={this.onClassChange} id="clas" required> 
								<option value="">Select Class</option>
								{
									items.map(function (item) {
										return <option value={item.class}>{item.cls}</option>;
									})
								}
							</select>&nbsp;&nbsp;
							Section : &nbsp;&nbsp;
							<select name="section" onChange={this.onSectionChange} id="secs" required>
								<option value="">Select Section</option>
								{
									sec.map(function (item) {
										return <option value={item.id}>{item.secs}</option>;
									})
								}			
							</select>
						</CardHeader>
						<CardBody>
							<Row>
							 <Col md="12">
								<Table responsive bordered  id="stdtable">
								  <thead>
									<tr>
										<th>S.No</th>
										<th>Reg no</th>
										<th>Student Name</th>
										<th>Section</th>
										<th>Status</th>
										<th>Remarks</th>
									</tr>
								  </thead>
								  <tbody>
									{this.state.postFilter.map((item,index) =>
										<tr key = {index}>
											<td>{index+1}</td>
											<td>{item.regno}</td>
											<td>{item.stdname}</td>
											<td>
											 <select name="section" onChange={this.onSecChange.bind(this,item.regno)} id="secs">
												<option value="">Select Section</option>
													{
														sec.map(function (item) {
															return <option value={item.id}>{item.secs}</option>;
														})
													}
											 </select>
											</td>
											<td>
											  <select name="stdstatus" onChange={this.onStatusChange.bind(this,item.regno)}>
												{this.stdstatus.map((e, key) => {
													return <option key={key} value={e.value}>{e.name}</option>;
												})}	
											 </select>
											</td>
											<td><input type="text" onBlur={this.onRemarkChange.bind(this,item.regno)} /></td>
										</tr>
									)}
								  </tbody>
								</Table>
							 </Col>
							</Row>
						</CardBody>
						<CardFooter>
							<Button type="submit" size="sm" color="primary" className="btn-right" ><i className="fa fa-dot-circle-o"></i> Update</Button>
						</CardFooter>
					</Card>
				  </Col>
				</Row>
			</form>
			</div>
		</div>
	)
  }
}

export default EditPromotion;


// WEBPACK FOOTER //
// ./src/Promotion/EditPromotion.js